import Completion from './Completion.vue';
import CompletionByPos from './completionByPos/CompletionByPos.vue';
import CompletionDetail from './completionDetail/CompletionDetail.vue';

export const completionRoutes = [
  {
    path: 'completion',
    component: Completion,
    children: [
      { path: ':pointOfSaleGuid', component: CompletionDetail, name: 'completion-detail' },
      { path: '', component: CompletionByPos, name: 'completion' },
    ]
  }
];
